import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ninxl/banks/page.tsx");
